import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class HeureTravailleeService {
  private API_URL = environment.API_URL;
  private MODEL_URL = 'heures-travaillees';

  constructor(private http: HttpClient) { }

  storeForDossierIntervention(valeurs){
    return this.http.post<boolean>(this.API_URL + this.MODEL_URL + '/dossiers-interventions/' + valeurs['dossier_intervention_id'], valeurs).pipe(
      catchError(err => throwError(err))
    );
  }
}
